<div class="calendarprintlistday__wrapper flex-row-start">
    <div class="calendarprintlistday__date">{{ day | date: "MMMM d" }}<br/><span>{{ day | date: "EEEE" }}</span></div>
    <div class="calendarprintlistday__content">
        <app-calendar-print-list-country *ngFor="let country of events | keyvalue; let last = last" [events]="country.value" [iso2]="country.key" [class.last-country]="last"></app-calendar-print-list-country>        
    </div>
</div>